/* eslint-disable no-unused-vars */
import React, { useContext, useRef } from 'react';
import { connect } from 'react-redux';
import clsx from 'clsx';
import {
  Box,
  Element,
  Color,
  Typography,
  Button,
  Icon,
  Size,
  Link
} from '@americanexpress/aqx-components';

import {
  DynamicAppModalContext,
  ModalButtonRefContext
} from 'src/universal/components/DynamicApp/redux';
import { hasPznDataArrived } from 'src/universal/redux/pznData';
import { getDynAppSideRailContent } from 'page_modules/business-pdp/redux';
import LazyScrollMetricTracker from 'src/universal/components/DTM/LazyScrollMetricTracker';
import { sendDTMClickEvent } from 'service_modules/models/dtm-tagging';
// import styles from './__styles__/index.scss?modules';

const DynamicAppLeftRail = ({
  content,
  disclaimerList,
  ctaProps,
  styles,
  hasPZNArrived,
  hasUpgradeCta
}) => {
  const setIsDynamicModalOpen = useContext(DynamicAppModalContext);
  const thisButtonRef = useRef(null);
  const { _, setButtonRef } = useContext(ModalButtonRefContext);
  const learnMoreButton = (
    <button
      className={styles.learnMoreButton}
      title={content.learnMoreLink.text}
      ref={thisButtonRef}
      onClick={() => {
        setButtonRef(thisButtonRef);
        setIsDynamicModalOpen();
        sendDTMClickEvent(content.learnMoreLink.dtm);
      }}
    >
      {content.learnMoreLink.text}
    </button>
  );
  //create DTM click event callback function
  const scrollDtm = {
    ...content.dtm,
    eventAsset: `${content.dtm.eventAsset}${content.shortName}`
  };
  const applyAndUpgradeCtas = ctaProps.map(
    ({ text, url, theme, Component, ariaLabel, ...rest }, i) => {
      const { icon, ...ctaProps } = rest;

      return (
        <Element key={i}>
          <Button
            href={url}
            Component={Component}
            $isMinMax={true}
            aria-label={ariaLabel}
            {...ctaProps}
          >
            {text}
          </Button>
        </Element>
      );
    }
  );
  return (
    <div>
      <Box
        className={clsx(styles.sideRailbox, {
          [styles.hasUpgradeCta]: hasUpgradeCta
        })}
      >
        <LazyScrollMetricTracker
          scrollDtm={scrollDtm}
          startTrackingAfterPznArrival={true}
        />
        <Typography
          id={styles.header}
          className={styles.header}
          theme={{
            color: Color.DeepBlue
          }}
        >
          {content.header}
        </Typography>
        <Typography
          className={styles.subheader}
          theme={{
            color: Color.Gray06
          }}
        >
          {learnMoreButton}
          {content.subheader}
        </Typography>
        {hasPZNArrived && applyAndUpgradeCtas}
      </Box>
      {disclaimerList ? (
        disclaimerList.map((item, index) => {
          return (
            <Link
              Component="a"
              className={styles.tnc}
              target={item.target}
              href={item.url}
              key={index}
              aria-label={item.ariaLabel}
            >
              {item.text}
            </Link>
          );
        })
      ) : (
        <></>
      )}
    </div>
  );
};
const mapStateToProps = state => {
  return {
    content: getDynAppSideRailContent(state),
    hasPZNArrived: hasPznDataArrived(state)
  };
};
export default connect(mapStateToProps)(DynamicAppLeftRail);
